// frontend/src/components/Input.js
import React, { useState, useRef, useEffect } from 'react';
import '../styles/Input.css';

const Input = ({ onSend, disabled }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);
  
  // Migliore gestione dell'altezza del textarea
  useEffect(() => {
    if (!textareaRef.current) return;
    
    // Imposta il limite massimo di altezza
    const maxHeight = 150;
    
    // Reimposta l'altezza prima di calcolare quella necessaria
    textareaRef.current.style.height = 'auto';
    
    // Calcola l'altezza necessaria e applicala, limitandola a maxHeight
    const scrollHeight = textareaRef.current.scrollHeight;
    textareaRef.current.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    
    // Se l'altezza è maggiore di maxHeight, abilita lo scrolling interno
    textareaRef.current.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
  }, [message]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSend(message);
      setMessage('');
      
      // Reset altezza del textarea in modo pulito
      if (textareaRef.current) {
        // Reset dell'altezza con un breve ritardo per evitare flickering
        setTimeout(() => {
          textareaRef.current.style.height = 'auto';
          textareaRef.current.style.overflowY = 'hidden';
        }, 10);
      }
    }
  };
  
  // Gestisce la pressione di Enter per inviare, Shift+Enter per andare a capo
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };
  
  return (
    <div className="input-wrapper">
      <form className="input-container" onSubmit={handleSubmit}>
        <textarea
          ref={textareaRef}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Descrivi il tuo problema..."
          disabled={disabled}
          onKeyDown={handleKeyDown}
          className="message-input"
          rows={1}
        />
        <button 
          type="submit" 
          disabled={disabled || !message.trim()}
          className="send-button"
          aria-label="Invia messaggio"
        >
          <span className="send-icon">↑</span>
        </button>
      </form>
      <div className="input-hint">
        Premi Enter per inviare, Shift+Enter per andare a capo
      </div>
    </div>
  );
};

export default Input;